import { render, staticRenderFns } from "./PFSettlementApprovalSectionFront.vue?vue&type=template&id=3117d2ca"
import script from "./PFSettlementApprovalSectionFront.vue?vue&type=script&lang=js"
export * from "./PFSettlementApprovalSectionFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports